import { GpActionType } from '../enum/gp-action-type.enum';
import { TranslationKeyMap } from '../gp-main.i18n';
import { ConstAction } from '../model/const-action.model';

export const gpActions = new Map<GpActionType, ConstAction>();

gpActions.set(GpActionType.FOLLOWUP, {
    classList: [
        'cmps-gp-color-followup-text',
        'cmps-gp-bg-color-followup-bg',
        'hover:cmps-gp-bg-color-followup-hover',
        'cmps-gp-border-color-followup-border',
    ].join(' '),
    isBestClassList: [
        'cmps-gp-color-followup-text',
        'cmps-gp-bg-color-followup-bg',
        'hover:cmps-gp-bg-color-followup-hover',
        'cmps-gp-border-color-followup-text',
        'cmps-cdk-font-bold',
    ].join(' '),
    headerClassList: 'cmps-gp-bg-gradient-followup-grad',
    icon: 'sync',
    iconFill: 'cmps-gp-fill-followup-text',
    label: TranslationKeyMap._11293_FOLLOW_UP,
    description: TranslationKeyMap._11332_DESC_FOLLOW_UP,
    tooltip: TranslationKeyMap.__TOOLTIP_FOLLOW_UP,
    badgeBgColor: 'cmps-gp-bg-color-followup-text',
    actionPickerBorderColor: 'cmps-gp-border-color-followup-text',
    actionPickerLabel: TranslationKeyMap._11298_SELECT_A_COMMITMENT,
});

gpActions.set(GpActionType.UPDATE, {
    classList: [
        'cmps-gp-color-update-text',
        'cmps-gp-bg-color-update-bg',
        'hover:cmps-gp-bg-color-update-hover',
        'cmps-gp-border-color-update-border',
    ].join(' '),
    isBestClassList: [
        'cmps-gp-color-update-text',
        'cmps-gp-bg-color-update-bg',
        'hover:cmps-gp-bg-color-update-hover',
        'cmps-gp-border-color-update-text',
        'cmps-cdk-font-bold',
    ].join(' '),
    headerClassList: 'cmps-gp-bg-gradient-update-grad',
    icon: 'calendar-clock-outline',
    iconFill: 'cmps-gp-fill-update-text',
    label: TranslationKeyMap._11295_UPDATE,
    description: TranslationKeyMap._11334_DESC_UPDATE,
    tooltip: TranslationKeyMap.__TOOLTIP_UPDATE,
    badgeBgColor: 'cmps-gp-bg-color-update-text',
    actionPickerBorderColor: 'cmps-gp-border-color-update-text',
    actionPickerLabel: TranslationKeyMap._11298_SELECT_A_COMMITMENT,
});

gpActions.set(GpActionType.COACH, {
    classList: [
        'cmps-gp-color-coach-text',
        'cmps-gp-bg-color-coach-bg',
        'hover:cmps-gp-bg-color-coach-hover',
        'cmps-gp-border-color-coach-border',
    ].join(' '),
    isBestClassList: [
        'cmps-gp-color-coach-text',
        'cmps-gp-bg-color-coach-bg',
        'hover:cmps-gp-bg-color-coach-hover',
        'cmps-gp-border-color-coach-text',
        'cmps-cdk-font-bold',
    ].join(' '),
    headerClassList: 'cmps-gp-bg-gradient-coach-grad',
    icon: 'whistle-outline',
    iconFill: 'cmps-gp-fill-coach-text',
    label: TranslationKeyMap._11294_COACH,
    description: TranslationKeyMap._11333_DESC_COACH,
    tooltip: TranslationKeyMap.__TOOLTIP_COACH,
    badgeBgColor: 'cmps-gp-bg-color-coach-text',
    actionPickerBorderColor: 'cmps-gp-border-color-coach-text',
    actionPickerLabel: TranslationKeyMap._11299_SELECT_AN_OPPORTUNITY,
});

gpActions.set(GpActionType.CELEBRATE, {
    classList: [
        'cmps-gp-color-celebrate-text',
        'cmps-gp-bg-color-celebrate-bg',
        'hover:cmps-gp-bg-color-celebrate-hover',
        'cmps-gp-border-color-celebrate-border',
    ].join(' '),
    isBestClassList: [
        'cmps-gp-color-celebrate-text',
        'cmps-gp-bg-color-celebrate-bg',
        'hover:cmps-gp-bg-color-celebrate-hover',
        'cmps-gp-border-color-celebrate-text',
        'cmps-cdk-font-bold',
    ].join(' '),
    headerClassList: 'cmps-gp-bg-gradient-celebrate-grad',
    icon: 'party-popper',
    iconFill: 'cmps-gp-fill-celebrate-text',
    label: TranslationKeyMap._11296_CELEBRATE,
    description: TranslationKeyMap._11335_DESC_CELEBRATE,
    tooltip: TranslationKeyMap.__TOOLTIP_CELEBRATE,
    badgeBgColor: 'cmps-gp-bg-color-celebrate-text',
    actionPickerBorderColor: 'cmps-gp-border-color-celebrate-text',
    actionPickerLabel: null,
});

gpActions.set(GpActionType.OBSERVE, {
    classList: [
        'cmps-gp-color-observe-text',
        'cmps-gp-bg-color-observe-bg',
        'hover:cmps-gp-bg-color-observe-hover',
        'cmps-gp-border-color-observe-border',
    ].join(' '),
    isBestClassList: [
        'cmps-gp-color-observe-text',
        'cmps-gp-bg-color-observe-bg',
        'hover:cmps-gp-bg-color-observe-hover',
        'cmps-gp-border-color-observe-text',
        'cmps-cdk-font-bold',
    ].join(' '),
    headerClassList: 'cmps-gp-bg-gradient-observe-grad',
    icon: 'eye-outline',
    iconFill: 'cmps-gp-fill-observe-text',
    label: TranslationKeyMap._11297_OBSERVE,
    description: TranslationKeyMap._11336_DESC_OBSERVE,
    tooltip: TranslationKeyMap.__TOOLTIP_OBSERVE,
    badgeBgColor: 'cmps-gp-bg-color-observe-text',
    actionPickerBorderColor: 'cmps-gp-border-color-observe-text',
    actionPickerLabel: TranslationKeyMap._11298_SELECT_A_COMMITMENT,
});

gpActions.set(GpActionType.REVIEW, {
    classList: [
        'cmps-gp-color-review-text',
        'cmps-gp-bg-color-review-bg',
        'hover:cmps-gp-bg-color-review-hover',
        'cmps-gp-border-color-review-border',
    ].join(' '),
    isBestClassList: [
        'cmps-gp-color-review-text',
        'cmps-gp-bg-color-review-bg',
        'hover:cmps-gp-bg-color-review-hover',
        'cmps-gp-border-color-review-text',
        'cmps-cdk-font-bold',
    ].join(' '),
    headerClassList: 'cmps-gp-bg-gradient-review-grad',
    icon: 'account-search-outline',
    iconFill: 'cmps-gp-fill-review-text',
    label: TranslationKeyMap._11341_REVIEW,
    description: TranslationKeyMap._11342_DESC_REVIEW,
    tooltip: TranslationKeyMap.__TOOLTIP_REVIEW,
    badgeBgColor: 'cmps-gp-bg-color-review-text',
    actionPickerBorderColor: 'cmps-gp-border-color-review-text',
    actionPickerLabel: null,
});

gpActions.set(GpActionType.APPROVE, {
    classList: [
        'cmps-gp-color-approve-text',
        'cmps-gp-bg-color-approve-bg',
        'hover:cmps-gp-bg-color-approve-hover',
        'cmps-gp-border-color-approve-border',
    ].join(' '),
    isBestClassList: [
        'cmps-gp-color-approve-text',
        'cmps-gp-bg-color-approve-bg',
        'hover:cmps-gp-bg-color-approve-hover',
        'cmps-gp-border-color-approve-text',
        'cmps-cdk-font-bold',
    ].join(' '),
    headerClassList: 'cmps-gp-bg-gradient-approve-grad',
    icon: 'clipboard-check-outline',
    iconFill: 'cmps-gp-fill-approve-text',
    label: TranslationKeyMap.__APPROVE,
    description: TranslationKeyMap.__DESC_APPROVE,
    tooltip: TranslationKeyMap.__TOOLTIP_APPROVE,
    badgeBgColor: 'cmps-gp-bg-color-approve-text',
    actionPickerBorderColor: 'cmps-gp-border-color-approve-text',
    actionPickerLabel: TranslationKeyMap._11298_SELECT_A_COMMITMENT,
});

gpActions.set(GpActionType.UPDATE_GOAL, {
    classList: [
        'cmps-gp-color-update-goal-text',
        'cmps-gp-bg-color-update-goal-bg',
        'hover:cmps-gp-bg-color-update-goal-hover',
        'cmps-gp-border-color-update-goal-border',
    ].join(' '),
    isBestClassList: [
        'cmps-gp-color-update-goal-text',
        'cmps-gp-bg-color-update-goal-bg',
        'hover:cmps-gp-bg-color-update-goal-hover',
        'cmps-gp-border-color-update-goal-text',
        'cmps-cdk-font-bold',
    ].join(' '),
    headerClassList: 'cmps-gp-bg-gradient-update-goal-grad',
    icon: 'flag-outline',
    iconFill: 'cmps-gp-fill-update-goal-text',
    label: TranslationKeyMap.__UPDATE_GOAL,
    description: TranslationKeyMap.__DESC_UPDATE_GOAL,
    tooltip: TranslationKeyMap.__TOOLTIP_UPDATE_GOAL,
    badgeBgColor: 'cmps-gp-bg-color-update-goal-text',
    actionPickerBorderColor: 'cmps-gp-border-color-update-goal-text',
    actionPickerLabel: TranslationKeyMap._11298_SELECT_A_COMMITMENT,
});

gpActions.set(GpActionType.UPDATE_EXPIRED, {
    classList: [
        'cmps-gp-color-update-expired-text',
        'cmps-gp-bg-color-update-expired-bg',
        'hover:cmps-gp-bg-color-update-expired-hover',
        'cmps-gp-border-color-update-expired-border',
    ].join(' '),
    isBestClassList: [
        'cmps-gp-color-update-expired-text',
        'cmps-gp-bg-color-update-expired-bg',
        'hover:cmps-gp-bg-color-update-expired-hover',
        'cmps-gp-border-color-update-expired-text',
        'cmps-cdk-font-bold',
    ].join(' '),
    headerClassList: 'cmps-gp-bg-gradient-update-expired-grad',
    icon: 'calendar-refresh-outline',
    iconFill: 'cmps-gp-fill-update-expired-text',
    label: TranslationKeyMap.__UPDATE_EXPIRED,
    description: TranslationKeyMap.__DESC_UPDATE_EXPIRED,
    tooltip: TranslationKeyMap.__TOOLTIP_UPDATE_EXPIRED,
    badgeBgColor: 'cmps-gp-bg-color-update-expired-text',
    actionPickerBorderColor: 'cmps-gp-border-color-update-expired-text',
    actionPickerLabel: TranslationKeyMap._11298_SELECT_A_COMMITMENT,
});

gpActions.set(GpActionType.ASSESS_PROFICIENCY, {
    classList: null,
    isBestClassList: null,
    headerClassList: 'cmps-gp-bg-gradient-assess-proficiency-grad',
    icon: 'star-outline',
    iconFill: 'cmps-gp-fill-assess-proficiency-text',
    label: TranslationKeyMap.__ASSESS_PROFICIENCY,
    description: TranslationKeyMap.__DESC_ASSESS_PROFICIENCY,
    tooltip: TranslationKeyMap.__TOOLTIP_ASSESS_PROFICIENCY,
    badgeBgColor: null,
    actionPickerBorderColor: null,
    actionPickerLabel: null,
});

gpActions.set(GpActionType.START_DEV_PLAN, {
    classList: [
        'cmps-gp-color-start-dev-plan-text',
        'cmps-gp-bg-color-start-dev-plan-bg',
        'hover:cmps-gp-bg-color-start-dev-plan-hover',
        'cmps-gp-border-color-start-dev-plan-border',
    ].join(' '),
    isBestClassList: [
        'cmps-gp-color-start-dev-plan-text',
        'cmps-gp-bg-color-start-dev-plan-bg',
        'hover:cmps-gp-bg-color-start-dev-plan-hover',
        'cmps-gp-border-color-start-dev-plan-text',
        'cmps-cdk-font-bold',
    ].join(' '),
    headerClassList: 'cmps-gp-bg-gradient-start-dev-plan-grad',
    icon: 'school-outline',
    iconFill: 'cmps-gp-fill-start-dev-plan-text',
    label: TranslationKeyMap.__START_DEV_PLAN,
    description: TranslationKeyMap.__DESC_START_DEV_PLAN,
    tooltip: TranslationKeyMap.__TOOLTIP_START_DEV_PLAN,
    badgeBgColor: 'cmps-gp-bg-color-start-dev-plan-text',
    actionPickerBorderColor: 'cmps-gp-border-color-start-dev-plan-text',
    actionPickerLabel: null,
});

gpActions.set(GpActionType.CHECK_IN, {
    classList: [
        'cmps-gp-color-check-in-text',
        'cmps-gp-bg-color-check-in-bg',
        'hover:cmps-gp-bg-color-check-in-hover',
        'cmps-gp-border-color-check-in-border',
    ].join(' '),
    isBestClassList: [
        'cmps-gp-color-check-in-text',
        'cmps-gp-bg-color-check-in-bg',
        'hover:cmps-gp-bg-color-check-in-hover',
        'cmps-gp-border-color-check-in-text',
        'cmps-cdk-font-bold',
    ].join(' '),
    headerClassList: 'cmps-gp-bg-gradient-check-in-grad',
    icon: 'update',
    iconFill: 'cmps-gp-fill-check-in-text',
    label: TranslationKeyMap.__CHECK_IN,
    description: TranslationKeyMap.__DESC_CHECK_IN,
    tooltip: TranslationKeyMap.__TOOLTIP_CHECK_IN,
    badgeBgColor: 'cmps-gp-bg-color-check-in-text',
    actionPickerBorderColor: 'cmps-gp-border-color-check-in-text',
    actionPickerLabel: TranslationKeyMap._11298_SELECT_A_COMMITMENT,
});

gpActions.set(GpActionType.CLOSE_OLD, {
    classList: [
        'cmps-gp-color-close-old-text',
        'cmps-gp-bg-color-close-old-bg',
        'hover:cmps-gp-bg-color-close-old-hover',
        'cmps-gp-border-color-close-old-border',
    ].join(' '),
    isBestClassList: [
        'cmps-gp-color-close-old-text',
        'cmps-gp-bg-color-close-old-bg',
        'hover:cmps-gp-bg-color-close-old-hover',
        'cmps-gp-border-color-close-old-text',
        'cmps-cdk-font-bold',
    ].join(' '),
    headerClassList: 'cmps-gp-bg-gradient-close-old-grad',
    icon: 'archive-outline',
    iconFill: 'cmps-gp-fill-close-old-text',
    label: TranslationKeyMap.__CLOSE_OLD,
    description: TranslationKeyMap.__DESC_CLOSE_OLD,
    tooltip: TranslationKeyMap.__TOOLTIP_CLOSE_OLD,
    badgeBgColor: 'cmps-gp-bg-color-close-old-text',
    actionPickerBorderColor: 'cmps-gp-border-color-close-old-text',
    actionPickerLabel: TranslationKeyMap._11298_SELECT_A_COMMITMENT,
});

gpActions.set(GpActionType.CLOSE_NEW_MANAGER, {
    classList: [
        'cmps-gp-color-close-new-manager-text',
        'cmps-gp-bg-color-close-new-manager-bg',
        'hover:cmps-gp-bg-color-close-new-manager-hover',
        'cmps-gp-border-color-close-new-manager-border',
    ].join(' '),
    isBestClassList: [
        'cmps-gp-color-close-new-manager-text',
        'cmps-gp-bg-color-close-new-manager-bg',
        'hover:cmps-gp-bg-color-close-new-manager-hover',
        'cmps-gp-border-color-close-new-manager-text',
        'cmps-cdk-font-bold',
    ].join(' '),
    headerClassList: 'cmps-gp-bg-gradient-close-new-manager-grad',
    icon: 'account-switch-outline',
    iconFill: 'cmps-gp-fill-close-new-manager-text',
    label: TranslationKeyMap.__CLOSE_NEW_MANAGER,
    description: TranslationKeyMap.__DESC_CLOSE_NEW_MANAGER,
    tooltip: TranslationKeyMap.__TOOLTIP_CLOSE_NEW_MANAGER,
    badgeBgColor: 'cmps-gp-bg-color-close-new-manager-text',
    actionPickerBorderColor: 'cmps-gp-border-color-close-new-manager-text',
    actionPickerLabel: TranslationKeyMap._11298_SELECT_A_COMMITMENT,
});

gpActions.set(GpActionType.COMPLETE, {
    classList: [
        'cmps-gp-color-complete-text',
        'cmps-gp-bg-color-complete-bg',
        'hover:cmps-gp-bg-color-complete-hover',
        'cmps-gp-border-color-complete-border',
    ].join(' '),
    isBestClassList: [
        'cmps-gp-color-complete-text',
        'cmps-gp-bg-color-complete-bg',
        'hover:cmps-gp-bg-color-complete-hover',
        'cmps-gp-border-color-complete-text',
        'cmps-cdk-font-bold',
    ].join(' '),
    headerClassList: 'cmps-gp-bg-gradient-complete-grad',
    icon: 'check',
    iconFill: 'cmps-gp-fill-complete-text',
    label: TranslationKeyMap.__COMPLETE,
    description: TranslationKeyMap.__DESC_COMPLETE,
    tooltip: TranslationKeyMap.__TOOLTIP_COMPLETE,
    badgeBgColor: 'cmps-gp-bg-color-complete-text',
    actionPickerBorderColor: 'cmps-gp-border-color-complete-text',
    actionPickerLabel: TranslationKeyMap._11298_SELECT_A_COMMITMENT,
});

gpActions.set(GpActionType.RESOLVE, {
    classList: [
        'cmps-gp-color-resolve-text',
        'cmps-gp-bg-color-resolve-bg',
        'hover:cmps-gp-bg-color-resolve-hover',
        'cmps-gp-border-color-resolve-border',
    ].join(' '),
    isBestClassList: [
        'cmps-gp-color-resolve-text',
        'cmps-gp-bg-color-resolve-bg',
        'hover:cmps-gp-bg-color-resolve-hover',
        'cmps-gp-border-color-resolve-text',
        'cmps-cdk-font-bold',
    ].join(' '),
    headerClassList: 'cmps-gp-bg-gradient-resolve-grad',
    icon: 'gavel',
    iconFill: 'cmps-gp-fill-resolve-text',
    label: TranslationKeyMap.__RESOLVE,
    description: TranslationKeyMap.__DESC_RESOLVE,
    tooltip: TranslationKeyMap.__TOOLTIP_RESOLVE,
    badgeBgColor: 'cmps-gp-bg-color-resolve-text',
    actionPickerBorderColor: 'cmps-gp-border-color-resolve-text',
    actionPickerLabel: TranslationKeyMap._11298_SELECT_A_COMMITMENT,
});
